module.exports = __webpack_public_path__ + "img/paymentMethod.a96ac4e6.svg";